import { mapObjectKeys } from '@elfsight/widget-utils';
import type { WidgetTitleProps, WidgetTitleSettings } from './types';

const settingsMap = {
  widgetTitle: 'enabled',
  widgetTitleTitle: 'title',
  widgetTitleCaption: 'caption',
  widgetTitleTitleColor: 'titleColor',
  widgetTitleCaptionColor: 'captionColor',
  widgetTitleLinksColor: 'linksColor',
  widgetTitleAlignment: 'alignment',
  widgetTitleTitleTextStyle: 'titleTextStyle',
  widgetTitleCaptionTextStyle: 'captionTextStyle'
};

export function mapWidgetTitleSettings(settings: WidgetTitleSettings) {
  const widgetTitleSettings = {
    widgetTitle: settings.widgetTitle,
    widgetTitleTitle: settings.widgetTitleTitle,
    widgetTitleCaption: settings.widgetTitleCaption,
    widgetTitleTitleColor: settings.widgetTitleTitleColor,
    widgetTitleCaptionColor: settings.widgetTitleCaptionColor,
    widgetTitleLinksColor: settings.widgetTitleLinksColor,
    widgetTitleAlignment: settings.widgetTitleAlignment,
    widgetTitleTitleTextStyle: settings.widgetTitleTitleTextStyle,
    widgetTitleCaptionTextStyle: settings.widgetTitleCaptionTextStyle
  };
  return mapObjectKeys<WidgetTitleProps>(widgetTitleSettings, settingsMap);
}
